var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1172 5.40234C41.7461 0.910156 33.8359 1.59375 28.8555 6.76953L27 8.72266L25.0469 6.76953C21.043 2.66797 13.0352 0.128906 6.78516 5.40234C0.632812 10.6758 0.339844 20.0508 5.80859 25.7148L24.7539 45.2461C25.3398 45.832 26.1211 46.125 26.9023 46.125C27.7812 46.125 28.5625 45.832 29.1484 45.2461L48.0938 25.7148C53.5625 20.0508 53.2695 10.6758 47.1172 5.40234ZM45.8477 23.5664L27 43.0977L8.05469 23.5664C4.34375 19.6602 3.5625 12.3359 8.83594 7.84375C14.207 3.25391 20.457 6.57422 22.8008 8.91797L27 13.2148L31.1016 8.91797C33.3477 6.57422 39.6953 3.25391 45.0664 7.84375C50.3398 12.3359 49.5586 19.6602 45.8477 23.5664Z",
    fill: "#52DD91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1b590fc2461448268786691598821425.svg";
export { ForwardRef as ReactComponent };